import React, { FC } from 'react'
import { ReactChild } from 'react'
import LoadIcon from '../../LoadIcon'
import { Container } from './styled'

interface LoaderType {
  loading: boolean
  children?: ReactChild
  fullPage?: boolean
}

export const Loader: FC<LoaderType> = ({ loading, children, fullPage }) => {
  if (loading) {
    return (
      <Container fullPage={fullPage}>
        <LoadIcon />
      </Container>
    )
  }

  return <>{children}</>
}
